import { Action } from '@ngrx/store';

export enum PackagingActionTypes {
  LoadPackaging = '[Packaging] Load Packaging info',
  LoadPackagingSuccess = '[Packaging] Load Packaging info success',
  LoadPackagingFail = '[Packaging] Load Packaging info fail',
  LoadPackagingById = '[Packaging] Load Packaging by id info',
  LoadPackagingByIdSuccess = '[Packaging] Load Packaging by id info success',
  LoadPackagingByIdFail = '[Packaging] Load Packaging info by id fail',
  CreatePackaging = '[Packaging] Create Packaging',
  CreatePackagingSuccess = '[Packaging] Create Packaging success',
  CreatePackagingFail = '[Packaging] Create Packaging fail',
  Update = '[Packaging] Update',
  UpdateSuccess = '[Packaging] Update success',
  UpdateFail = '[Packaging] Update fail',
  Delete = '[Packaging] delete',
  DeleteSuccess = '[Packaging] delete success',
  DeleteFail = '[Packaging] delete fail',
  DeleteManagementFollowPackaging = '[Packaging] delete management follow packaging',
  DeleteManagementFollowPackagingSuccess = '[Packaging] delete management follow packaging success',
  DeleteManagementFollowPackagingFail = '[Packaging] delete management follow packaging fail',
  AddManagementFollowPackaging = '[Packaging] add management follow packaging',
  AddManagementFollowPackagingSuccess = '[Packaging] add management follow packaging success',
  AddManagementFollowPackagingFail = '[Packaging] add management follow packaging fail',
  ExportPackaging = '[Packaging] export packaging',
  ExportPackagingSuccess = '[Packaging] export packaging success',
  ExportPackagingPending = '[Packaging] export packaging pending',
  ExportPackagingJobSuccess = '[Packaging] export packaging job success',
  ExportPackagingFail = '[Packaging] export packaging fail',
  ImportFile = '[Packaging] import packaging',
  ImportFileSuccess = '[Packaging] import packaging success',
  ImportFileFail = '[Packaging] import packaging fail',
  UploadFile = '[Packaging] upload packaging file',
  UploadFileSuccess = '[Packaging] upload packaging file success',
  UploadFileFail = '[Packaging] upload packaging file fail',
  UploadProcessUpdate = '[Packaging] upload packaging file process update',
  UploadProcessUpdateAccept = '[Packaging] upload packaging file process update accept',
  UploadProcessSuccess = '[Packaging] upload packaging file process success',
  UploadProcessFail = '[Packaging] upload packaging file process fail',
  DuplicatePackaging = '[Packaging] duplicate packaging',
  DuplicatePackagingSuccess = '[Packaging] duplicate packaging success',
  DuplicatePackagingFail = '[Packaging] duplicate packaging fail',
  ClearState = '[Packaging] clear state',
  DuplicateWithCodes = '[Packaging] duplicate packaging with codes',
  DuplicateWithCodesSuccess = '[Packaging] duplicate packaging with codes success',
  DuplicateWithCodesFail = '[Packaging] duplicate packaging with codes fail',
  DownloadAllProviders = '[Packaging] download all providers packaging',
  DownloadAllProvidersSuccess = '[Packaging] download all providers packaging success',
  DownloadAllProvidersFail = '[Packaging] download all providers packaging fail',
  UploadImgsPackagingFields = '[Packaging] upload img packaging field',
  UploadImgsPackagingFieldsSuccess = '[Packaging] upload img packaging field success',
  UploadImgsPackagingFieldsFail = '[Packaging] upload img packaging field fail',
  UploadFileImg = '[Packaging] upload link file',
  DeleteImagePackaging = '[Packaging] delete image packaging',
  DeleteImagePackagingSuccess = '[Packaging] delete image packaging success',
  DeleteImagePackagingFail = '[Packaging] delete image packaging fail',
  PackagingPendingMessage = '[Packaging] packaging pending message',
  PackagingExportMassivePending = '[Packaging] packaging export massive pending',
  PackagingExportMassiveSuccess = '[Packaging] packaging export massive success',
  PackagingExportMassiveFail = '[Packaging] packaging export massive fail',
  PackagingExportMassiveFinish = '[Packaging] packaging export massive finish',
  GetPackagingCountries = '[Packaging] get packaging countries',
  GetPackagingCountriesSuccess = '[Packaging] get packaging countries success',
  GetPackagingCountriesFail = '[Packaging] get packaging countries fail',
  GetPackagingMilestones = '[Packaging] get packaging milestones',
  GetPackagingMilestonesSuccess = '[Packaging] get packaging milestones success',
  GetPackagingMilestonesFail = '[Packaging] get packaging milestones fail',
  AgrupatedPacks = '[Packaging] agrupated packs',
  AgrupatedPacksPending = '[Packaging] agrupated packs pending',
  AgrupatedPacksSuccess = '[Packaging] agrupated packs success',
  AgrupatedPacksFail = '[Packaging] agrupated packs fail',
  ExportPackOrder = '[Packaging] export packaging order',
  ExportPackOrderLoadSuccess = '[Packaging] export packaging order load success',
  ExportPackOrderSuccess = '[Packaging] export packaging order success',
  ExportPackOrderFail = '[Packaging] export packaging order fail',
  DownloadPackagingMaster = '[Packaging] download packaging master',
  DownloadPackagingMasterSuccess = '[Packaging] download packaging master success',
  DownloadPackagingMasterFail = '[Packaging] download packaging master fail',
  DownloadPackagingMasterFields = '[Packaging] download packaging fields master',
  DownloadPackagingMasterFieldsSuccess = '[Packaging] download packaging master fields success',
  DownloadPackagingMasterFieldsFail = '[Packaging] download packaging master fields fail',
  PackagingFieldsUpdate = '[Packaging] procesing fields update',
  PackagingFieldsUpdateFail = '[Packaging] procesing fields update fail',
  PackagingFieldsUpdateSuccess = '[Packaging] procesing fields update success',
  FetchAllMasterPackagings = '[Packaging] fetch all master packagings',
  FetchAllMasterPackagingsSuccess = '[Packaging] fetch all master packagings success',
  FetchAllMasterPackagingsFail = '[Packaging] fetch all master packagings fail'
}

export class LoadPackaging implements Action {
  readonly type = PackagingActionTypes.LoadPackaging;
  constructor(public id?: any) {}
}

export class LoadPackagingSuccess implements Action {
  readonly type = PackagingActionTypes.LoadPackagingSuccess;
  constructor(public data: any) {}
}

export class LoadPackagingFail implements Action {
  readonly type = PackagingActionTypes.LoadPackagingFail;
  constructor(public error: any) {}
}

export class LoadPackagingById implements Action {
  readonly type = PackagingActionTypes.LoadPackagingById;
  constructor(public id?: any, public mode?: any) {}
}

export class LoadPackagingByIdSuccess implements Action {
  readonly type = PackagingActionTypes.LoadPackagingByIdSuccess;
  constructor(public data: any) {}
}

export class LoadPackagingByIdFail implements Action {
  readonly type = PackagingActionTypes.LoadPackagingByIdFail;
  constructor(public error: any) {}
}

export class CreatePackaging implements Action {
  readonly type = PackagingActionTypes.CreatePackaging;
  constructor(public data: any) {}
}

export class CreatePackagingSuccess implements Action {
  readonly type = PackagingActionTypes.CreatePackagingSuccess;
  constructor(public data: any) {}
}

export class CreatePackagingFail implements Action {
  readonly type = PackagingActionTypes.CreatePackagingFail;
  constructor(public error: any) {}
}

export class Update implements Action {
  readonly type = PackagingActionTypes.Update;
  constructor(public id: number, public data?: any, public name?: string) {}
}

export class UpdateSuccess implements Action {
  readonly type = PackagingActionTypes.UpdateSuccess;
  constructor(public id: number, public data: any) {}
}

export class UpdateFail implements Action {
  readonly type = PackagingActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class Delete implements Action {
  readonly type = PackagingActionTypes.Delete;
  constructor(public id: number) {}
}

export class DeleteSuccess implements Action {
  readonly type = PackagingActionTypes.DeleteSuccess;
  constructor() {}
}

export class DeleteFail implements Action {
  readonly type = PackagingActionTypes.DeleteFail;
  constructor(public data: any) {}
}

export class DeleteManagementFollowPackaging implements Action {
  readonly type = PackagingActionTypes.DeleteManagementFollowPackaging;
  constructor(public id: number, public data?: any) {}
}

export class DeleteManagementFollowPackagingSuccess implements Action {
  readonly type = PackagingActionTypes.DeleteManagementFollowPackaging;
  constructor(public id: number, public data?: any) {}
}

export class DeleteManagementFollowPackagingFail implements Action {
  readonly type = PackagingActionTypes.DeleteManagementFollowPackagingFail;
  constructor(public error: any) {}
}

export class AddManagementFollowPackaging implements Action {
  readonly type = PackagingActionTypes.AddManagementFollowPackaging;
  constructor(public id: number, public data?: any) {}
}

export class AddManagementFollowPackagingSuccess implements Action {
  readonly type = PackagingActionTypes.AddManagementFollowPackagingSuccess;
  constructor(public id: number, public data?: any) {}
}

export class AddManagementFollowPackagingFail implements Action {
  readonly type = PackagingActionTypes.AddManagementFollowPackagingFail;
  constructor(public error: any) {}
}

export class ExportPackaging implements Action {
  readonly type = PackagingActionTypes.ExportPackaging;
  constructor(
    public id: number,
    public role?: string,
    public followId?: number,
    public packagingId?: number,
    public typePack?: string,
    public downloabled?: boolean,
    public providerName?: string,
    public unitBusiness?: any,
    public country?: any
  ) {}
}

export class ExportPackagingSuccess implements Action {
  readonly type = PackagingActionTypes.ExportPackagingSuccess;
  constructor() {}
}

export class ExportPackagingPending implements Action {
  readonly type = PackagingActionTypes.ExportPackagingPending;
  constructor(public message: string) {}
}

export class ExportPackagingJobSuccess implements Action {
  readonly type = PackagingActionTypes.ExportPackagingJobSuccess;
  constructor(public data: any, public name: string) {}
}

export class ExportPackagingFail implements Action {
  readonly type = PackagingActionTypes.ExportPackagingFail;
  constructor(public error: any) {}
}

export class PackagingExportMassivePending implements Action {
  readonly type = PackagingActionTypes.PackagingExportMassivePending;
  constructor(public message: string, public data?: any) {}
}

export class PackagingExportMassiveSuccess implements Action {
  readonly type = PackagingActionTypes.PackagingExportMassiveSuccess;
  constructor(public message: string, public data: any, public followId: any) {}
}

export class PackagingExportMassiveFinish implements Action {
  readonly type = PackagingActionTypes.PackagingExportMassiveFinish;
  constructor() {}
}

export class PackagingExportMassiveFail implements Action {
  readonly type = PackagingActionTypes.PackagingExportMassiveFail;
  constructor(public message: string, public error?: any) {}
}

export class ImportFile implements Action {
  readonly type = PackagingActionTypes.ImportFile;
  constructor(
    public file: any,
    public packaginId?: number,
    public typeMode?: string,
    public isSpecial?: boolean
  ) {}
}

export class ImportFileSuccess implements Action {
  readonly type = PackagingActionTypes.ImportFileSuccess;
  constructor(public data?: any) {}
}

export class ImportFileFail implements Action {
  readonly type = PackagingActionTypes.ImportFileFail;
  constructor(public error?: any) {}
}

export class UploadFile implements Action {
  readonly type = PackagingActionTypes.UploadFile;
  constructor(
    public uploadUrl: string,
    public FileId: number,
    public file: any,
    public typeMode?: string,
    public isSpecial?: boolean
  ) {}
}

export class UploadFileSuccess implements Action {
  readonly type = PackagingActionTypes.UploadFileSuccess;
  constructor(public FileId?: number, public typeMode?: string) {}
}

export class UploadFileFail implements Action {
  readonly type = PackagingActionTypes.UploadFileFail;
  constructor(public error: any) {}
}

export class UploadProcessUpdate implements Action {
  readonly type = PackagingActionTypes.UploadProcessUpdate;
  constructor(public data: any) {}
}

export class UploadProcessUpdateAccept implements Action {
  readonly type = PackagingActionTypes.UploadProcessUpdateAccept;
  constructor(public data?: any) {}
}

export class UploadProcessSuccess implements Action {
  readonly type = PackagingActionTypes.UploadProcessSuccess;
  constructor(public data?: any) {}
}

export class UploadProcessFail implements Action {
  readonly type = PackagingActionTypes.UploadProcessFail;
  constructor(public error: any) {}
}

export class DuplicatePackaging implements Action {
  readonly type = PackagingActionTypes.DuplicatePackaging;
  constructor(public id: number) {}
}

export class DuplicatePackagingSuccess implements Action {
  readonly type = PackagingActionTypes.DuplicatePackagingSuccess;
  constructor(public data?: any) {}
}

export class DuplicatePackagingFail implements Action {
  readonly type = PackagingActionTypes.DuplicatePackagingFail;
  constructor(public error?: any) {}
}

export class ClearState implements Action {
  readonly type = PackagingActionTypes.ClearState;
  constructor() {}
}

export class DuplicateWithCodes implements Action {
  readonly type = PackagingActionTypes.DuplicateWithCodes;
  constructor(public packId: number, public objPackaging: any) {}
}

export class DuplicateWithCodesSuccess implements Action {
  readonly type = PackagingActionTypes.DuplicateWithCodesSuccess;
  constructor(public data?: any) {}
}

export class DuplicateWithCodesFail implements Action {
  readonly type = PackagingActionTypes.DuplicateWithCodesFail;
  constructor(public error?: any) {}
}

export class DownloadAllProviders implements Action {
  readonly type = PackagingActionTypes.DownloadAllProviders;
  constructor(public PackagingId: number) {}
}

export class DownloadAllProvidersSuccess implements Action {
  readonly type = PackagingActionTypes.DownloadAllProvidersSuccess;
  constructor(public data?: any) {}
}

export class DownloadAllProvidersFail implements Action {
  readonly type = PackagingActionTypes.DownloadAllProvidersFail;
  constructor(public error?: any) {}
}

export class UploadImgsPackagingFields implements Action {
  readonly type = PackagingActionTypes.UploadImgsPackagingFields;
  constructor(
    public packagingId: number,
    public file: any,
    public featured = false,
    public followId?: number
  ) {}
}

export class UploadImgsPackagingFieldsSuccess implements Action {
  readonly type = PackagingActionTypes.UploadImgsPackagingFieldsSuccess;
  constructor(public data?: any) {}
}

export class UploadImgsPackagingFieldsFail implements Action {
  readonly type = PackagingActionTypes.UploadImgsPackagingFieldsFail;
  constructor(public error?: any) {}
}

export class UploadFileImg implements Action {
  readonly type = PackagingActionTypes.UploadFileImg;
  constructor(public link: any, public file: any) {}
}

export class GetPackagingCountries implements Action {
  readonly type = PackagingActionTypes.GetPackagingCountries;
  constructor(public packId: number) {}
}

export class GetPackagingCountriesSuccess implements Action {
  readonly type = PackagingActionTypes.GetPackagingCountriesSuccess;
  constructor(public data: any) {}
}

export class GetPackagingCountriesFail implements Action {
  readonly type = PackagingActionTypes.GetPackagingCountriesFail;
  constructor(public error?: any) {}
}

export class DeleteImagePackaging implements Action {
  readonly type = PackagingActionTypes.DeleteImagePackaging;
  constructor(public packId: number, public data?: any) {}
}

export class DeleteImagePackagingSuccess implements Action {
  readonly type = PackagingActionTypes.DeleteImagePackagingSuccess;
  constructor(public data?: any) {}
}

export class DeleteImagePackagingFail implements Action {
  readonly type = PackagingActionTypes.DeleteImagePackagingFail;
  constructor(public error?: any) {}
}

export class PackagingPendingMessage implements Action {
  readonly type = PackagingActionTypes.PackagingPendingMessage;
  constructor(public message: any) {}
}

export class GetPackagingMilestones implements Action {
  readonly type = PackagingActionTypes.GetPackagingMilestones;
  constructor() {}
}

export class GetPackagingMilestonesSuccess implements Action {
  readonly type = PackagingActionTypes.GetPackagingMilestonesSuccess;
  constructor(public data: any) {}
}

export class GetPackagingMilestonesFail implements Action {
  readonly type = PackagingActionTypes.GetPackagingMilestonesFail;
  constructor(public error?: any) {}
}

export class AgrupatedPacks implements Action {
  readonly type = PackagingActionTypes.AgrupatedPacks;
  constructor(public data: any) {}
}

export class AgrupatedPacksPending implements Action {
  readonly type = PackagingActionTypes.AgrupatedPacks;
  constructor() {}
}

export class AgrupatedPacksSuccess implements Action {
  readonly type = PackagingActionTypes.AgrupatedPacksSuccess;
  constructor(public data: any) {}
}

export class AgrupatedPacksFail implements Action {
  readonly type = PackagingActionTypes.AgrupatedPacksFail;
  constructor(public error?: any) {}
}

export class ExportPackOrder implements Action {
  readonly type = PackagingActionTypes.ExportPackOrder;
  constructor(public packId: number) {}
}

export class ExportPackOrderLoadSuccess implements Action {
  readonly type = PackagingActionTypes.ExportPackOrderLoadSuccess;
  constructor(public packId: number) {}
}

export class ExportPackOrderSuccess implements Action {
  readonly type = PackagingActionTypes.ExportPackOrderSuccess;
  constructor() {}
}

export class ExportPackOrderFail implements Action {
  readonly type = PackagingActionTypes.ExportPackOrderFail;
  constructor(public error?: any) {}
}

export class DownloadPackagingMaster implements Action {
  readonly type = PackagingActionTypes.DownloadPackagingMaster;
  constructor() {}
}

export class DownloadPackagingMasterSuccess implements Action {
  readonly type = PackagingActionTypes.DownloadPackagingMasterSuccess;
  constructor() {}
}

export class DownloadPackagingMasterFail implements Action {
  readonly type = PackagingActionTypes.DownloadPackagingMasterFail;
  constructor(public error?: any) {}
}

export class DownloadPackagingMasterFields implements Action {
  readonly type = PackagingActionTypes.DownloadPackagingMasterFields;
  constructor() {}
}

export class DownloadPackagingMasterFieldsSuccess implements Action {
  readonly type = PackagingActionTypes.DownloadPackagingMasterFieldsSuccess;
  constructor() {}
}

export class DownloadPackagingMasterFieldsFail implements Action {
  readonly type = PackagingActionTypes.DownloadPackagingMasterFieldsFail;
  constructor(public error?: any) {}
}

export class PackagingFieldsUpdateFail implements Action {
  readonly type = PackagingActionTypes.PackagingFieldsUpdateFail;
  constructor(public data: any) {}
}

export class PackagingFieldsUpdate implements Action {
  readonly type = PackagingActionTypes.PackagingFieldsUpdate;
  constructor(public data: any) {}
}

export class PackagingFieldsUpdateSuccess implements Action {
  readonly type = PackagingActionTypes.PackagingFieldsUpdateSuccess;
  constructor(public data: any) {}
}

export class FetchAllMasterPackagings implements Action {
  readonly type = PackagingActionTypes.FetchAllMasterPackagings;
  constructor() {}
}

export class FetchAllMasterPackagingsSuccess implements Action {
  readonly type = PackagingActionTypes.FetchAllMasterPackagingsSuccess;
  constructor(public data?: any) {}
}

export class FetchAllMasterPackagingsFail implements Action {
  readonly type = PackagingActionTypes.FetchAllMasterPackagingsFail;
  constructor(public error?: any) {}
}

export type PackagingActionsUnion =
  | LoadPackaging
  | LoadPackagingSuccess
  | LoadPackagingFail
  | LoadPackagingById
  | LoadPackagingByIdSuccess
  | LoadPackagingByIdFail
  | CreatePackaging
  | CreatePackagingSuccess
  | CreatePackagingFail
  | Update
  | UpdateSuccess
  | UpdateFail
  | Delete
  | DeleteSuccess
  | DeleteFail
  | DeleteManagementFollowPackaging
  | DeleteManagementFollowPackagingSuccess
  | DeleteManagementFollowPackagingFail
  | AddManagementFollowPackaging
  | AddManagementFollowPackagingSuccess
  | AddManagementFollowPackagingFail
  | ExportPackaging
  | ExportPackagingSuccess
  | ExportPackagingPending
  | ExportPackagingJobSuccess
  | ExportPackagingFail
  | ImportFile
  | ImportFileSuccess
  | ImportFileFail
  | UploadFile
  | UploadFileSuccess
  | UploadFileFail
  | UploadProcessUpdate
  | UploadProcessUpdateAccept
  | UploadProcessSuccess
  | UploadProcessFail
  | DuplicatePackaging
  | DuplicatePackagingSuccess
  | DuplicatePackagingFail
  | ClearState
  | DuplicateWithCodes
  | DuplicateWithCodesSuccess
  | DuplicateWithCodesFail
  | DownloadAllProviders
  | DownloadAllProvidersSuccess
  | DownloadAllProvidersFail
  | UploadImgsPackagingFields
  | UploadImgsPackagingFieldsSuccess
  | UploadImgsPackagingFieldsFail
  | UploadFileImg
  | GetPackagingCountries
  | GetPackagingCountriesSuccess
  | GetPackagingCountriesFail
  | PackagingExportMassivePending
  | PackagingExportMassiveSuccess
  | PackagingExportMassiveFinish
  | PackagingExportMassiveFail
  | DeleteImagePackaging
  | DeleteImagePackagingSuccess
  | DeleteImagePackagingFail
  | PackagingPendingMessage
  | GetPackagingMilestones
  | GetPackagingMilestonesSuccess
  | GetPackagingMilestonesFail
  | AgrupatedPacks
  | AgrupatedPacksSuccess
  | AgrupatedPacksFail
  | ExportPackOrder
  | ExportPackOrderSuccess
  | ExportPackOrderFail
  | ExportPackOrderLoadSuccess
  | DownloadPackagingMaster
  | DownloadPackagingMasterSuccess
  | DownloadPackagingMasterFail
  | FetchAllMasterPackagings
  | FetchAllMasterPackagingsSuccess
  | FetchAllMasterPackagingsFail
  | DownloadPackagingMasterFields
  | DownloadPackagingMasterFieldsSuccess
  | DownloadPackagingMasterFieldsFail
  | PackagingFieldsUpdate
  | PackagingFieldsUpdateFail
  | PackagingFieldsUpdateSuccess;
